var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { API_PATHS } from "../types/apiPaths";
import { DATE_RANGE_FILTER_PARAMS } from "../utils/dateRangeFilters";
import { MAX_LIST_LIMIT } from "../utils/fetchAllPages";
export var fetchTitles = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, search_1, _b, offset, _c, limit, sortBy, searchParams_1, criteriaKeys, defaultSortFields, sortFields, url, response, error_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                _a = filters.search, search_1 = _a === void 0 ? {} : _a, _b = filters.offset, offset = _b === void 0 ? 0 : _b, _c = filters.limit, limit = _c === void 0 ? MAX_LIST_LIMIT : _c, sortBy = filters.sortBy;
                searchParams_1 = new URLSearchParams();
                searchParams_1.set("offset", offset.toString());
                searchParams_1.set("limit", limit.toString());
                criteriaKeys = __spreadArray([
                    "id",
                    "name",
                    "contributor",
                    "publisher",
                    "productNumber",
                    "collection",
                    "hasCommentForAgency"
                ], DATE_RANGE_FILTER_PARAMS, true);
                criteriaKeys.forEach(function (key) {
                    var value = search_1[key];
                    if (value !== undefined) {
                        searchParams_1.set(key, value);
                    }
                });
                defaultSortFields = search_1.contributor
                    ? ["firstContributor", "mainTitle", "publisher"]
                    : ["mainTitle", "firstContributor", "publisher"];
                sortFields = sortBy && sortBy.length > 0 ? sortBy : defaultSortFields;
                sortFields.forEach(function (field) { return searchParams_1.append("sortBy", field); });
                url = "".concat(API_PATHS.TITLES_SEARCH, "?").concat(searchParams_1.toString());
                return [4 /*yield*/, kyInstance.get(url, {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _d.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
            case 2:
                error_1 = _d.sent();
                console.error("Error fetching titles:", error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchTitleById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("titles/".concat(id), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_2 = _a.sent();
                console.error("Error fetching title by ID:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var createTitle = function (kyInstance, title) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post("titles", {
                        json: title,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error("Error creating title:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var updateTitle = function (kyInstance, id, title) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.put("titles/".concat(id), {
                        json: title,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Update error: ".concat(response.statusText));
                }
                return [2 /*return*/];
            case 2:
                error_4 = _a.sent();
                console.error("Error updating title:", error_4);
                throw error_4;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var deleteTitle = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.delete("titles/".concat(id), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Delete error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_5 = _a.sent();
                console.error("Error deleting title:", error_5);
                throw error_5;
            case 3: return [2 /*return*/];
        }
    });
}); };
